module.exports = __webpack_public_path__ + "img/nodata.58ef6f99.png";